
<div
  :class="['value-display', size, { subtle }]"
  v-tooltip="{ content: tooltipContent, delay: { show: 1000, hide: 100 }, placement: 'bottom' }"
  @click="handleClick"
>
  <template v-if="estimated">
    <stat-item label="Estimated Value" :size="size" :value="value" />
  </template>

  <template v-else>
    <value-logo />

    <align no-gap>
      <icon v-if="shouldBlurValue" class="blur-icon" name="visibility" />
      <span v-else class="price" :class="{ loading }">
        {{ value }}
      </span>

      <external-link href="https://cardladder.zendesk.com/hc/en-us/articles/11943684520471--Card-Ladder-Value-The-Intersection-of-Player-Indexes-Price-Modeling" />
    </align>
  </template>

  <span v-show="confidence && value !== 'N/A'" :class="['confidence-bars', `confidence-${confidence}`]">
    <span class="bar active" />
    <span :class="['bar', { active: confidence >= 2 }]" />
    <span :class="['bar', { active: confidence >= 3 }]" />
    <span :class="['bar', { active: confidence >= 4 }]" />
    <span :class="['bar', { active: confidence >= 5 }]" />
  </span>
</div>
